"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helper_1 = require("./helper");
var ComposeType;
(function (ComposeType) {
    ComposeType[ComposeType["New"] = 0] = "New";
    ComposeType[ComposeType["Reply"] = 1] = "Reply";
    ComposeType[ComposeType["ReplyAll"] = 2] = "ReplyAll";
    ComposeType[ComposeType["Forward"] = 3] = "Forward";
    ComposeType[ComposeType["EditDraft"] = 4] = "EditDraft";
    ComposeType[ComposeType["Approve"] = 5] = "Approve";
    ComposeType[ComposeType["Reject"] = 6] = "Reject";
})(ComposeType = exports.ComposeType || (exports.ComposeType = {}));
var States;
(function (States) {
    States[States["UnStarted"] = 0] = "UnStarted";
    States[States["Started"] = 1] = "Started";
    States[States["Restarting"] = 2] = "Restarting";
    States[States["Restarted"] = 3] = "Restarted";
    States[States["Open"] = 4] = "Open";
    States[States["Complete"] = 5] = "Complete";
    States[States["Faulted"] = 6] = "Faulted";
    States[States["Inactive"] = 7] = "Inactive";
    States[States["BuildingWSB"] = 8] = "BuildingWSB";
    States[States["WSBOpen"] = 9] = "WSBOpen";
})(States = exports.States || (exports.States = {}));
class Attachment {
    constructor(fileName, fileType) {
        this.fileName = fileName;
        this.fileType = fileType;
    }
}
exports.Attachment = Attachment;
class UrlParam {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
exports.UrlParam = UrlParam;
class Recipient {
    constructor(address, name, mailboxType) {
        this.a = address;
        this.n = name;
        if (mailboxType) {
            this.t = helper_1.getType(mailboxType);
        }
    }
}
exports.Recipient = Recipient;
class Email {
    constructor(subject, sender, to, cc, bcc, date, body) {
        this.subject = subject;
        this.sender = sender;
        this.to = to;
        this.cc = cc;
        this.bcc = bcc;
        this.date = date;
        this.body = body;
    }
}
exports.Email = Email;
class Envelope {
    constructor(user, dateTime, constraints, subject, to) {
        this.user = user;
        this.dateTime = dateTime;
        this.constraints = constraints;
        this.subject = subject;
        if (to.length > Envelope.MAX_RECIPIENT_NUM) {
            to = to.slice(0, 3);
        }
        this.to = to;
    }
}
exports.Envelope = Envelope;
Envelope.MAX_RECIPIENT_NUM = 3;
class RequestsInfo {
    constructor(startTime, context) {
        this.time = startTime;
        this.context = context;
    }
}
exports.RequestsInfo = RequestsInfo;
class Actor {
    constructor(actorId, actorIdType, actorType = "User", aadTenantId) {
        this.actorId = "PUID:" + actorId;
        this.actorIdType = actorIdType;
        this.aadTenantId = aadTenantId;
        this.actorType = actorType;
    }
}
exports.Actor = Actor;
class Application {
    constructor(appId, appName, appVer) {
        this.aadAppId = appId;
        this.appName = appName;
        this.appVer = appVer;
    }
}
exports.Application = Application;
class Device {
    constructor(os, osVer, userAgent) {
        this.os = os;
        this.osVer = osVer;
        this.userAgent = userAgent;
    }
}
exports.Device = Device;
class SessionInfo {
    constructor(actor, application, device, composeType) {
        this.actor = actor;
        this.application = application;
        this.device = device;
        this.composeType = composeType;
    }
}
exports.SessionInfo = SessionInfo;
class UserMetrics {
    constructor(acceptCount, rejectCount, satCount, dsatCount) {
        this.acc = acceptCount >= 0 ? acceptCount : 0;
        this.rej = rejectCount >= 0 ? rejectCount : 0;
        this.sat = satCount >= 0 ? satCount : 0;
        this.dsat = dsatCount >= 0 ? dsatCount : 0;
    }
}
exports.UserMetrics = UserMetrics;
class SuggestionRequest {
    constructor(salutationRequired, e2ePreLatency, suggestionAccepted, requestNumber, cvId) {
        this.sr = salutationRequired;
        this.l = e2ePreLatency;
        this.ac = suggestionAccepted;
        this.i = requestNumber;
        this.cv = cvId;
    }
}
exports.SuggestionRequest = SuggestionRequest;
